<template>
  <ul class="nav nav-tabs nav-justified mb-3" id="ex1" role="tablist">
    <li class="nav-item" role="presentation">
      <a class="nav-link active" id="ex-tab-1" data-bs-toggle="tab" href="#ex-tabs-1" role="tab" aria-controls="ex-tabs-1" aria-selected="true">Repasse</a>
    </li>
    <li class="nav-item" role="presentation">
      <a class="nav-link" id="ex-tab-2" data-bs-toggle="tab" href="#ex-tabs-2" role="tab" aria-controls="ex-tabs-2" aria-selected="false">Histórico de Repasse do Paciente</a>
    </li>
  </ul>
  <div class="tab-content" id="ex-content">
    <div class="tab-pane fade show active" id="ex-tabs-1" role="tabpanel" aria-labelledby="ex-tab-1">
      <div class="row">
        <div class="col">
          <label>Para</label>
          <div class="input-group input-focus">
            <a-auto-complete v-model:value="formConsult.nome" @search="handleProfSearch" class="form-control">
              <template v-slot:dataSource>
                <a-select-option v-for="prof in profSearch" :key="prof.id" :value="prof.nome" @click="onSelectProf(prof)">
                  {{ prof.nome }}
                </a-select-option>
              </template>
            </a-auto-complete>
          </div>
        </div>
        <div class="col-3">
          <label>CPF</label>
          <div class="input-group input-focus">
            <a-auto-complete style="width: 200px" v-model:value="formConsult.cpf" v-mask="'###.###.###-##'" @search="handleSearchProfCpf" class="form-control">
              <template v-slot:dataSource>
                <a-select-option v-for="item in profCpfSearch" :key="item.id" :value="item.nome" @click="onSelectProf(item)">
                  {{ item.nome }}
                </a-select-option>
              </template>
            </a-auto-complete>
          </div>
        </div>
        <div class="col-sm-1" style="width: 6%; margin-left: -22px">
          <div class="input-group-prepend" style="margin-top: 23px">
            <span class="input-group-text bg-white" @click="pesquisar"><i class="fa fa-search"></i></span>
          </div>
        </div>
      </div>
      <div class="row">
        <a-table :dataSource="profissional" :columns="columnsRepasse">
          <template #paciente="{ record }">
            <span>{{ record.paciente.nome }}</span>
          </template>
          <template #profissionalRemetente="{ record }">
            <span>{{ record.profissionalRemetente.nome }}</span>
          </template>
          <template #profissionalDestinatario="{ record }">
            <span>{{ record.profissionalDestinatario.nome }}</span>
          </template>
          <template #idTermoAceite="{ record }">
            <div class="row" v-if="!record.idTermoAceite">
              <div class="col">
                <label for="formFileSm" class="form-label">Importar Arquivo</label>
                <input class="form-control form-control-sm" id="formFileSm" type="file" name="file" ref="files" multiple @input="pegaArquivo(record, $event)" />
              </div>
              <div class="col-1">
                <a-tooltip title="Envio Termo" placement="right">
                  <i class="fa-solid fa-upload upload-archive" style="cursor: pointer" @click="uploadFile(record)"></i>
                </a-tooltip>
              </div>
            </div>
            <div v-if="record.idTermoAceite">
              <a-tooltip title="Download do Termo" placement="top">
                <i class="far fa-file-alt upload-archive" style="margin-left: 2%; cursor: pointer" @click="baixarArquivo(record)"></i>
              </a-tooltip>
              <a-tooltip title="Deletar do Termo" placement="top">
                <i class="fa-solid fa-trash upload-archive" style="margin-left: 2%; cursor: pointer" @click="deletarTermo(record)"></i>
              </a-tooltip>
            </div>
          </template>
          <template #dataAtendimento="{ record }">
            {{ returnaDataFormatada(record.dataEnvio) }}
          </template>
          <template #action="{ record }">
            <a-tooltip title="Remover da Tabela" placement="top">
              <i class="fa-solid fa-trash upload-archive" style="margin-left: 2%; cursor: pointer" @click="removerTabela(record)"></i>
            </a-tooltip>
            <a-tooltip title="Enviar Repasse do Atendimento" placement="top">
              <i class="fa-solid fa-paper-plane upload-archive" id="BotaoEnviar" style="cursor: pointer" @click="enviarRepasse(record.idTermoAceite)"></i>
            </a-tooltip>
          </template>
        </a-table>
      </div>
    </div>
    <div class="tab-pane fade" id="ex-tabs-2" role="tabpanel" aria-labelledby="ex-tab-2">
      <div class="row">
        <a-table :dataSource="historico" :columns="columnsDocuments">
          <template #paciente="{ record }">
            <span>{{ record.paciente.nome }}</span>
          </template>
          <template #profissionalRemetente="{ record }">
            <span>{{ record.profissionalRemetente.nome }}</span>
          </template>
          <template #profissionalDestinatario="{ record }">
            <span>{{ record.profissionalDestinatario.nome }}</span>
          </template>
          <template #idTermoAceite="{ record }">
            <a-tooltip title="Download do Termo" placement="top">
              <i class="far fa-file-alt upload-archive" style="margin-left: 44%; cursor: pointer" @click="baixarArquivo(record)"></i>
            </a-tooltip>
          </template>
          <template #dataEnvio="{ record }">
            {{ dataFormatada(record.dataEnvio) }}
          </template>
          <template #dataResposta="{ record }">
            {{ dataFormatada(record.dataResposta) }}
          </template>
        </a-table>
      </div>
    </div>
  </div>
</template>

<script>
import { getProfissional, getProfissionalByCpf } from '@/components/service/profissionalService';
import { openNotification, typesNotification } from '@/utils/notifications';
import { formatarData } from '@/utils/servicos-utils';
import { createRepasse, getRepassePorPacienteId, getRepasseStatusSolicitadoPorPacienteId } from '@/components/service/RepasseAtendimento';
import { getDataUser } from '@/utils';
import { downloadDocumentFileWs, isArquivoValido, sendDocumentFileWs } from '@/utils/filews';

export default {
  name: 'RepasseAtendimentoPaciente',
  props: {
    //registroAtendimento: {
    paciente: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      historico: [],
      profissional: [],
      profissionalDestinatario: null,
      profissionalRemetente: null,
      repassePaciente: undefined,
      profSearch: [],
      profCpfSearch: [],
      dataUser: getDataUser(),
      formConsult: {
        idPaciente: null,
        idProfissional: null,
        cpf: null,
      },
      columnsDocuments: [
        {
          title: 'Paciente',
          dataIndex: 'paciente',
          key: 'paciente',
          slots: { customRender: 'paciente' },
        },
        {
          title: 'De',
          dataIndex: 'profissionalRemetente',
          key: 'profissionalRemetente',
          slots: { customRender: 'profissionalRemetente' },
        },
        {
          title: 'Para',
          dataIndex: 'profissionalDestinatario',
          key: 'profissionalDestinatario',
          slots: { customRender: 'profissionalDestinatario' },
        },
        {
          title: 'Termo de Aceite',
          dataIndex: 'idTermoAceite',
          key: 'idTermoAceite',
          slots: { customRender: 'idTermoAceite' },
        },
        {
          title: 'Data Envio',
          dataIndex: 'dataEnvio',
          key: 'dataEnvio',
          slots: { customRender: 'dataEnvio' },
        },
        {
          title: 'Data Resposta',
          dataIndex: 'dataResposta',
          key: 'dataResposta',
          slots: { customRender: 'dataResposta' },
        },
        {
          title: 'Situação',
          dataIndex: 'situacaoRepasse',
          key: 'situacaoRepasse',
          slots: { customRender: 'situacaoRepasse' },
        },
      ],
      columnsRepasse: [
        {
          title: 'Paciente',
          dataIndex: 'paciente',
          key: 'paciente',
          slots: { customRender: 'paciente' },
        },
        {
          title: 'De',
          dataIndex: 'profissionalRemetente',
          key: 'profissionalRemetente',
          slots: { customRender: 'profissionalRemetente' },
        },
        {
          title: 'Para',
          dataIndex: 'profissionalDestinatario',
          key: 'profissionalDestinatario',
          slots: { customRender: 'profissionalDestinatario' },
        },
        {
          title: 'Termo de Aceite',
          dataIndex: 'idTermoAceite',
          key: 'idTermoAceite',
          slots: { customRender: 'idTermoAceite' },
        },
        {
          title: 'Ação',
          dataIndex: 'action',
          key: 'action',
          slots: { customRender: 'action' },
        },
      ],
    };
  },
  async created() {
    await this.getHistorico();
    await this.getMyProf();
  },
  methods: {
    async getHistorico() {
      await getRepassePorPacienteId(this.paciente.id).then((r) => {
        this.historico = r.data.reverse();
      });
    },
    async getMyProf() {
      await getProfissionalByCpf(this.dataUser.cpf).then((r) => {
        this.profissionalRemetente = r.data;
      });
    },
    async handleProfSearch(value) {
      value.length >= 3
        ? await getProfissional({ nome: value }).then((r) => {
            this.profSearch = r.data.profissionais;
          })
        : (this.profSearch = []);
    },
    async handleSearchProfCpf(value) {
      value.length === 14
        ? await getProfissional({ cpf: value.replace('-', '').replaceAll('.', '') }).then((r) => {
            this.profCpfSearch = r.data.profissionais;
          })
        : (this.profCpfSearch = []);
    },
    onSelectProf(prof) {
      this.formConsult.idProfissional = prof.id;
      this.formConsult.nome = prof.nome;
      this.formConsult.cpf = prof.cpf;
      this.profissionalDestinatario = prof;
    },
    async pesquisar() {
      if (this.dataUser.cpf === this.profissionalDestinatario.cpf) {
        openNotification(typesNotification.warning, 'Não é possível repassar para o mesmo profissional.');
      } else {
        await getRepasseStatusSolicitadoPorPacienteId(this.paciente.id).then((r) => {
          if (r.data.length > 0) {
            console.log(r.data);
            openNotification(typesNotification.warning, 'ja foi solicitado o repasse desse paciente para o profissional [' + r.data[0].profissionalDestinatario.nome + '] aguarde a recusa ou aceite do repasse solicitado.');
          } else {
            let obj = {
              paciente: this.paciente,
              profissionalRemetente: this.profissionalRemetente,
              profissionalDestinatario: this.profissionalDestinatario,
            };
            this.profissional.push(obj);
          }
        });
      }
    },
    returnaDataFormatada(obj) {
      let data = formatarData(new Date(obj.dataHoraInicio), 'DD/MM/YYYY');
      let horaInicio = formatarData(new Date(obj.dataHoraInicio), 'HH:mm');
      let horaFim = formatarData(new Date(obj.dataHoraFim), 'HH:mm');

      return data + ' ' + horaInicio + ' ás ' + horaFim;
    },
    dataFormatada(obj) {
      if (obj) {
        return formatarData(new Date(obj), 'DD/MM/YYYY HH:mm');
      } else {
        return '';
      }
    },
    async enviarRepasse(validacao) {
      if (validacao) {
        await createRepasse(this.profissional[0]).then(() => {
          document.getElementById('BotaoEnviar').onclick = null;
          this.$socket.send('Repasse enviado');
          this.profissional = [];
          this.getHistorico();
          openNotification(typesNotification.success, 'Repasse do paciente foi enviado com sucesso.');
        });
      } else {
        openNotification(typesNotification.warning, 'Importe um Termo de Aceite do Paciente');
      }
    },
    pegaArquivo(record, value) {
      record.file = value.target.files;
    },
    async uploadFile(record) {
      if (record.file[0]) {
        let validarTamanho = isArquivoValido('', '', record.file[0].size, true);
        if (validarTamanho.tamanho) {
          await sendDocumentFileWs(record.file[0], 'TOKEN', 'ssp').then(async (r) => {
            record.idTermoAceite = r.data.id;
            record.nomeArquivo = r.data.nomeOriginal;
            openNotification(typesNotification.success, 'Arquivo enviado com sucesso');
          });
        } else {
          openNotification(typesNotification.error, 'Tamanho de arquivo não suportado.');
        }
      } else {
        openNotification(typesNotification.warning, 'Importe o termo de aceite antes de fazer o upload.');
      }
    },
    async baixarArquivo(record) {
      await downloadDocumentFileWs(record.idTermoAceite, record.nomeArquivo);
    },
    deletarTermo(record) {
      record.idTermoAceite = undefined;
      record.nomeArquivo = undefined;
    },
    removerTabela(record) {
      this.profissional.splice(this.profissional.indexOf(record), 1);
    },
  },
};
</script>

<style scoped>
.upload-archive {
  font-size: 25px;
  margin-top: 5px;
}
</style>
